// The server's monthly AI allowance (services/ai_meter.py) answers 429
// "ai_monthly_limit" from every AI route; one clear message, app-wide.
export function aiLimitMessage(error, lang) {
  const response = error?.response;
  if (response?.status !== 429 || response?.data?.detail !== 'ai_monthly_limit') return null;
  return lang === 'da'
    ? 'Du har brugt dine AI-point for denne måned. De fyldes op den 1. i næste måned — se saldoen i Skuret.'
    : 'You have used your AI points for this month. They refill on the 1st of next month — see your balance in the Shed.';
}
